module.exports = __webpack_public_path__ + "static/avatar_anastasia_spiridonova@2x-7028005ec314a93f6401e8eac685e23f.jpg";